import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-sm align-middle mb-0 conflict-table" }
const _hoisted_3 = { scope: "col" }

import { conflictBadgeClass, conflictLevelLabel } from "../../../conflictFormat";

// Each row: { level, when, subject, partner }. The caller normalises its data into rows so this
// table stays presentation-only and can be shared across conflict surfaces.

export default {
  __name: 'ConflictTable',
  props: {
	rows: { type: Array, default: () => [] },
	// Header for the time column ("Termine" for grouped lists, "Termin" for a single occurrence).
	whenLabel: { type: String, default: "Termine" },
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _cache[0] || (_cache[0] = _createElementVNode("th", { scope: "col" }, " Art ", -1 /* CACHED */)),
          _createElementVNode("th", _hoisted_3, _toDisplayString(__props.whenLabel), 1 /* TEXT */),
          _cache[1] || (_cache[1] = _createElementVNode("th", { scope: "col" }, " Betroffen ", -1 /* CACHED */)),
          _cache[2] || (_cache[2] = _createElementVNode("th", { scope: "col" }, " Konflikt mit ", -1 /* CACHED */))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, [
              _createElementVNode("span", {
                class: _normalizeClass(["badge", _unref(conflictBadgeClass)(row.level)])
              }, _toDisplayString(_unref(conflictLevelLabel)(row.level)), 3 /* TEXT, CLASS */)
            ]),
            _createElementVNode("td", null, _toDisplayString(row.when), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(row.subject), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(row.partner), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}
}

}